/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.taxconfiguration.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../../../../validate/validate_pb.js')

var witbooking_backoffice_common_common_pb = require('../../../../witbooking/backoffice/common/common_pb.js')
const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.taxconfiguration = {};
proto.witbooking.backoffice.taxconfiguration.v1 = require('./taxconfiguration_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.taxconfiguration.v1.TaxConfigurationAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.taxconfiguration.v1.TaxConfigurationAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationRequest,
 *   !proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse>}
 */
const methodDescriptor_TaxConfigurationAPI_GetTaxConfiguration = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.taxconfiguration.v1.TaxConfigurationAPI/GetTaxConfiguration',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationRequest,
  proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse,
  /**
   * @param {!proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationRequest,
 *   !proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse>}
 */
const methodInfo_TaxConfigurationAPI_GetTaxConfiguration = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse,
  /**
   * @param {!proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.taxconfiguration.v1.TaxConfigurationAPIClient.prototype.getTaxConfiguration =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.taxconfiguration.v1.TaxConfigurationAPI/GetTaxConfiguration',
      request,
      metadata || {},
      methodDescriptor_TaxConfigurationAPI_GetTaxConfiguration,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.taxconfiguration.v1.TaxConfigurationAPIPromiseClient.prototype.getTaxConfiguration =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.taxconfiguration.v1.TaxConfigurationAPI/GetTaxConfiguration',
      request,
      metadata || {},
      methodDescriptor_TaxConfigurationAPI_GetTaxConfiguration);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationRequest,
 *   !proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationResponse>}
 */
const methodDescriptor_TaxConfigurationAPI_UpdateTaxConfiguration = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.taxconfiguration.v1.TaxConfigurationAPI/UpdateTaxConfiguration',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationRequest,
  proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationResponse,
  /**
   * @param {!proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationRequest,
 *   !proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationResponse>}
 */
const methodInfo_TaxConfigurationAPI_UpdateTaxConfiguration = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationResponse,
  /**
   * @param {!proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.taxconfiguration.v1.TaxConfigurationAPIClient.prototype.updateTaxConfiguration =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.taxconfiguration.v1.TaxConfigurationAPI/UpdateTaxConfiguration',
      request,
      metadata || {},
      methodDescriptor_TaxConfigurationAPI_UpdateTaxConfiguration,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.taxconfiguration.v1.TaxConfigurationAPIPromiseClient.prototype.updateTaxConfiguration =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.taxconfiguration.v1.TaxConfigurationAPI/UpdateTaxConfiguration',
      request,
      metadata || {},
      methodDescriptor_TaxConfigurationAPI_UpdateTaxConfiguration);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationRequest,
 *   !proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationResponse>}
 */
const methodDescriptor_TaxConfigurationAPI_DeleteTaxConfiguration = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.taxconfiguration.v1.TaxConfigurationAPI/DeleteTaxConfiguration',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationRequest,
  proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationResponse,
  /**
   * @param {!proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationRequest,
 *   !proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationResponse>}
 */
const methodInfo_TaxConfigurationAPI_DeleteTaxConfiguration = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationResponse,
  /**
   * @param {!proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.taxconfiguration.v1.TaxConfigurationAPIClient.prototype.deleteTaxConfiguration =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.taxconfiguration.v1.TaxConfigurationAPI/DeleteTaxConfiguration',
      request,
      metadata || {},
      methodDescriptor_TaxConfigurationAPI_DeleteTaxConfiguration,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.taxconfiguration.v1.TaxConfigurationAPIPromiseClient.prototype.deleteTaxConfiguration =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.taxconfiguration.v1.TaxConfigurationAPI/DeleteTaxConfiguration',
      request,
      metadata || {},
      methodDescriptor_TaxConfigurationAPI_DeleteTaxConfiguration);
};


module.exports = proto.witbooking.backoffice.taxconfiguration.v1;

